interface RateLimitConfig {
  maxAttempts: number;
  timeWindow: number; // in milliseconds
}

class RateLimiter {
  private attempts: Map<string, number[]>;
  private config: RateLimitConfig;

  constructor(config: RateLimitConfig) {
    this.attempts = new Map();
    this.config = config;
  }

  private getKey(identifier: string): string {
    return `form_submit_${identifier}`;
  }

  private cleanupOldAttempts(attempts: number[]): number[] {
    const now = Date.now();
    return attempts.filter(time => now - time < this.config.timeWindow);
  }

  canSubmit(identifier: string): boolean {
    const key = this.getKey(identifier);
    const now = Date.now();
    let attempts = this.attempts.get(key) || [];
    
    // Clean up old attempts
    attempts = this.cleanupOldAttempts(attempts);
    
    // Check if we've exceeded the limit
    if (attempts.length >= this.config.maxAttempts) {
      return false;
    }
    
    // Add new attempt
    attempts.push(now);
    this.attempts.set(key, attempts);
    
    return true;
  }

  getRemainingTime(identifier: string): number {
    const key = this.getKey(identifier);
    const attempts = this.attempts.get(key) || [];
    const now = Date.now();
    
    if (attempts.length === 0) return 0;
    
    const oldestAttempt = attempts[0];
    const timeElapsed = now - oldestAttempt;
    
    return Math.max(0, this.config.timeWindow - timeElapsed);
  }
}

// Create a singleton instance with default config
// 5 attempts per 5 minutes
export const formRateLimiter = new RateLimiter({
  maxAttempts: 5,
  timeWindow: 5 * 60 * 1000 // 5 minutes in milliseconds
}); 